export * from './register.page'
